export default __webpack_public_path__ + "static/media/property_590.11bb0114.png";